import React from 'react';

import {
  Button,
  Group,
  Modal,
  ModalProps,
  Stack,
  Text,
  ThemeIcon,
  Title,
  useMantineTheme,
  px,
  Badge,
} from '@mantine/core';
import { IconCalendarPlus, IconClock } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { ProfileRetrieve } from 'types/generated';

type DemoPeriodExpiredCtaModalProps = Pick<ModalProps, 'opened' | 'onClose'> & {
  profile: ProfileRetrieve | null;
};

const DemoPeriodExpiredCtaModal = ({
  opened,
  onClose,
  profile,
}: DemoPeriodExpiredCtaModalProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Modal opened={opened} onClose={onClose} trapFocus centered size='lg'>
      <Stack spacing='xl' p='xl'>
        <Stack align='center'>
          <ThemeIcon variant='light' radius='100%' size={px(theme.fontSizes.xl) * 3} color='yellow'>
            <IconClock size={px(theme.fontSizes.md) * 2} />
          </ThemeIcon>

          <Title order={2} fw={600}>
            Demo Period Expired
          </Title>
          <Text color='dimmed' align='center'>
            Your 48-hour demo access for
            <Text fw={700} span>
              {` ${profile?.fullName} `}
            </Text>
            has ended.
          </Text>
        </Stack>

        {profile?.demoGym?.expiresAt && (
          <Stack mb='xl'>
            <Group align='flex-end' position='apart'>
              <Stack spacing='xs'>
                <Text fw={700}>{profile?.fullName}</Text>
                <Text color='dimmed'>
                  Demo ended: {dayjs(profile?.demoGym?.expiresAt).format('MMMM D, YYYY')} at{' '}
                  {dayjs(profile?.demoGym?.expiresAt).format('hh:MM A')}
                </Text>
              </Stack>

              <Badge color='red'>Expired</Badge>
            </Group>
          </Stack>
        )}

        <Stack mt='xl' align='center'>
          <Title order={3} fw={600}>
            Ready to get started?
          </Title>
          <Text color='dimmed' align='center' px='xl' sx={{ textWrap: 'pretty' }}>
            Contact your Kilo Sales Advisor to extend your Trial or setup your live account
          </Text>

          <Button
            leftIcon={<IconCalendarPlus size={theme.fontSizes.xl} />}
            component='a'
            href='https://usekilo.com/book-your-sales-call/'
            size='lg'
            fullWidth
            mt='md'
            mb='xl'
          >
            Schedule a Call
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default DemoPeriodExpiredCtaModal;
